import { useState } from "react";
import { format, isValid } from "date-fns";
import { TrashIconSvg } from "../../svgs/trashIconSvg";
import { ConfirmModal } from "../../components/confirmModal";
import { toast } from "react-toastify";
import { EditIconSvg } from "../../svgs/editIconSvg";
import GIFT_CARDS from "../../api/services/GIFT_CARDS";
import EditGiftCardModal from "../../components/EditGiftCardModal";
import CreateGiftCardModal from "../../components/CreateGiftCardModal";
import { IMAGE_BASE_URL } from "../../config";
import styles from "../../styles/_containers/_giftCards/table.module.scss";

const safeFormat = (dateStr, fmt) => {
  if (!dateStr) return "-";
  const d = new Date(dateStr);
  return isValid(d) ? format(d, fmt) : "-";
};

const Table = ({ data, setResponseStatus }) => {
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  // handle delete gift cards
  const handleDeleteGiftCard = async () => {
    try {
      setDeleteLoading(true);
      const res = await GIFT_CARDS.delete_gift_card(isConfirmModalOpen);
      toast.success(res.data.message);
      setResponseStatus(true);
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.message);
    } finally {
      setIsConfirmModalOpen(false);
      setDeleteLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h2>גיפט קארדס</h2>
        <div className={styles.btns}>
          <button onClick={() => setIsCreateModalOpen(true)}>יצירת גיפט חדש</button>
        </div>
      </div>
      <div className={styles.tableWrapper}>
        <table>
          <thead>
            <tr>
              <th>תמונה</th>
              <th>שם</th>
              <th>סוג הנחה</th>
              <th>תוקף</th>
              <th>מספר רכישות</th>
              <th>סטטוס</th>
              <th>תוקף</th>
              <th>נוצר בתאריך</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {data.length === 0 && (
              <tr>
                <td colSpan={10}>
                  <p>לא נמצאו גיפטים</p>
                </td>
              </tr>
            )}
            {data.map((i) => (
              <tr key={i._id}>
                <td>
                  {i.imageType ? (
                    <img
                      src={`${IMAGE_BASE_URL}/uploads/${i.imageType}`}
                      alt={i.name}
                      style={{ width: 40, height: 40, objectFit: "cover", borderRadius: 6 }}
                    />
                  ) : (
                    <span style={{ fontSize: 24 }}>🎁</span>
                  )}
                </td>
                <td>{i.name}</td>
                <td>{i.priceType}</td>
                <td>{safeFormat(i.expiryDate, "dd/MM/yyyy")}</td>
                <td>{i.noOfBuyers}</td>
                <td>
                  <button
                    className={`${!i.isActive ? styles.red : styles.green}`}
                  >
                    {i.isActive ? "פעיל" : "לא פעיל"}
                  </button>
                </td>
                <td>
                  <button
                    className={`${i.expired ? styles.red : styles.green}`}
                  >
                    {i.expired ? "פג תוקף" : "פעיל"}
                  </button>
                </td>
                <td>{safeFormat(i.createdAt, "dd/MM/yyyy")}</td>
                <td>
                  <div className={styles.icons}>
                    <div
                      style={{ cursor: "pointer" }}
                      onClick={() => setIsEditModalOpen(i._id)}
                    >
                      <EditIconSvg fill="blue" />
                    </div>
                    &nbsp; &nbsp;
                    <div
                      style={{ cursor: "pointer" }}
                      onClick={() => setIsConfirmModalOpen(i._id)}
                    >
                      <TrashIconSvg fill="red" />
                    </div>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* DELETE MODAL */}
      {isConfirmModalOpen && (
        <ConfirmModal
          setIsOpen={setIsConfirmModalOpen}
          handleClick={handleDeleteGiftCard}
          loading={deleteLoading}
        />
      )}

      {/* CREATE MODAL */}
      {isCreateModalOpen && (
        <CreateGiftCardModal
          setIsOpen={setIsCreateModalOpen}
          setResponseStatus={setResponseStatus}
        />
      )}

      {/* EDIT MODAL */}
      {isEditModalOpen && (
        <EditGiftCardModal
          setIsOpen={setIsEditModalOpen}
          giftCardId={isEditModalOpen}
          setResponseStatus={setResponseStatus}
        />
      )}
    </div>
  );
};

export default Table;
